/* ILS — TASK-1684 — open the popular-searches suggest panel when the
   user focuses the INLINE search input at the top of the page.

   Existing behaviour (custom-overrides.js): tap [data-ils-lens] in the
   collapsed header -> toggles body.ils-suggest-open. Closing is owned
   by the backdrop click + Esc key handlers in that file.

   TASK-2240 update — the .ils-suggest panel opens on top of the inline
   input, and the panel renders its OWN <input> that visually replaces
   what the user tapped. In the previous version focus stayed on the
   inline input while the suggest input is what the user could see,
   so typing went to the covered field and the visible one stayed
   empty until the user tapped a second time. On the touchstart of
   the inline input we now (1) open the panel and (2) synchronously
   move focus to the suggest input so the keyboard targets the input
   the user is looking at. touchstart runs before the native focus
   is committed, so we also cancel the browser's default focus on
   the inline input to avoid a stray blur/focus roundtrip. */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  function focusSuggestInput() {
    var suggestInput = document.querySelector(
      '.ils-suggest .ils-search input[type="search"]'
    );
    if (!suggestInput) return;
    try { suggestInput.focus({ preventScroll: true }); }
    catch (_) { suggestInput.focus(); }
  }

  ready(function () {
    // The inline search input lives inside .ils-search-section (top of page),
    // NOT inside .ils-suggest (the panel itself).
    var inlineInput = document.querySelector(
      '.ils-search-section .ils-search input[type="search"]'
    );
    if (!inlineInput) return;

    // On focus of the inline input: open the panel and immediately move
    // focus to the .ils-suggest input the user visually sees. The .focus()
    // call runs synchronously inside the user-gesture-driven focus event,
    // so iOS re-targets the keyboard at the suggest input in-place — no
    // second tap needed.
    inlineInput.addEventListener('focus', function () {
      document.body.classList.add('ils-suggest-open');
      var active = document.activeElement;
      var alreadyOnSuggest = active && active.closest && active.closest('.ils-suggest');
      if (!alreadyOnSuggest) focusSuggestInput();
    });
  });
})();
